import { ApiListResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { CollaborationTemplateDto } from '@oncolens/oncolens-ui/lib/dto/event/request';
import { useQuery, UseQueryOptions } from 'react-query';
import api from '@/utils/httpClient';

export const getTemplates = () => {
  return api
    .get('/api/collaborationtemplates')
    .then((response) => (response.data as ApiListResponse<CollaborationTemplateDto>).data);
};

export const useGetTemplates = (options?: UseQueryOptions<CollaborationTemplateDto[]>) => {
  return useQuery('templates', () => getTemplates(), {
    ...options,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    staleTime: Infinity
  });
};
